import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export interface CartTotalChangedPayload {
  newTotal: number;
}

export class CartTotalChangedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor(public readonly payload: CartTotalChangedPayload) {
  }
}
